import { Box, Text, Icon } from '@nimbus-ds/components';
import { ExclamationCircleIcon } from '@nimbus-ds/icons';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface ErrorMessageProps {
  error?: string;
}

export function ErrorMessage({ error }: Readonly<ErrorMessageProps>) {
  const t = useTranslationConfigurations();

  if (!error) return null;

  const errorMessage = error.startsWith('domains.') ? t(error) : error;

  return (
    <Box display="flex" alignItems="center" gap="1">
      <Icon
        color="danger-textLow"
        source={<ExclamationCircleIcon size={12} />}
      />
      <Text fontSize="caption" color="danger-textLow">
        {errorMessage}
      </Text>
    </Box>
  );
}
